module.exports = __webpack_public_path__ + "static/media/1 lion backpiece black and grey realistic hyper realism .1280x1540.a564ff54.webp";